import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import classes from './styles/index.module.scss';
import FlexGrid, { FlexGridColumn } from '../../../../../../ReactSharedScripts/components/FlexGrid';
import { syncManager } from '../../../../../../ReactSharedScripts/utils/syncManager';
import { PAGE_HEADER_CLASS, PAGE_HEADER_STICKY_CLASS } from '../../../../../../ReactSharedScripts/modules/header/const';

const HeaderListPageSection = () => {
	const textboxPortalClasses = classNames(classes.search, 'listPageHeaderSearch');
	const filterButtonPortalClasses = classNames('listPageHeaderFilterButton');
	const [mounted, setIsMounted] = useState(false);

	useEffect(() => {
		setIsMounted(true);
	}, []);

	useEffect(() => {
		if (!mounted) {
			return;
		}

		syncManager.emit('react', 'onListPageHeaderSearchPortalContainerRender');
		syncManager.emit('react', 'onListSidebarIndicatorPortalContainerRender');

		const headerPortal = document.querySelector(`.${PAGE_HEADER_CLASS}`);

		if (headerPortal && !headerPortal.classList.contains(PAGE_HEADER_STICKY_CLASS)) {
			headerPortal.classList.add(PAGE_HEADER_STICKY_CLASS);
		}
	}, [mounted]);

	return (
		<FlexGrid className={classes.headerListPageSection}>
			<FlexGridColumn className={textboxPortalClasses} />
			<FlexGridColumn className={filterButtonPortalClasses} />
		</FlexGrid>
	);
};

export default HeaderListPageSection;
